import React from 'react';

import { testimonials, testimonials_beam } from '../MainPage/Settings/plans/Testimonials';
import { SidepanelCarousel } from './SidepanelCarousel';
import { isBeamUser } from '../Utils/usersTypes';
import loginStyles from '../Styles/publicRoutes/login.module.less';
import styles from '../Styles/publicRoutes/style.module.less';
import { ATTENTIVE_AI, BEAM_AI } from '../Constants/Urls';

export const LoginTestimonialSidepanel = ({ isLoadingLoginLogo, logo }: $TSFixMe) => {
  const { loginSidepanel, aaiLogo, beamLogo } = loginStyles;
  const { sidepanelTriangles, topRight, rotated, bottomLeft } = styles;
  const beamUser = isBeamUser();

  return (
    <div className={loginSidepanel}>
      <a href={beamUser ? BEAM_AI : ATTENTIVE_AI} target='_blank'>
        {!isLoadingLoginLogo && (
          <img
            src={
              beamUser
                ? 'https://storage.googleapis.com/falcon-shared-images-front-end/assets/beam_ai_logo_02e611abc6-711f-45a4-9579-03b9bf5f3cd4.png'
                : logo || 'https://storage.googleapis.com/falcon-prod-filestore/prod/Automeasure%20logo-05.png'
            }
            alt={logo || 'Attentive Logo'}
            className={`${aaiLogo} ${beamUser && beamLogo}`}
          />
        )}
      </a>

      {!isLoadingLoginLogo && !logo && (
        <SidepanelCarousel testimonials={isBeamUser() ? testimonials_beam : testimonials} />
      )}

      <img
        src='https://storage.googleapis.com/falcon-shared-images-front-end/assets/svgs/triangles.svg'
        className={`${sidepanelTriangles} ${topRight}`}
        alt='Attentive Triangles'
      />
      <img
        src='https://storage.googleapis.com/falcon-shared-images-front-end/assets/svgs/triangles.svg'
        className={`${sidepanelTriangles} ${bottomLeft} ${rotated}`}
        alt='Attentive Triangles'
      />
    </div>
  );
};
